import { useEffect } from "react";
import api from "../components/api.js";

const useAutoLogout = () => {

  useEffect(() => {

    let timeout;

    const logout = () => {

      api.post("/account/logout").catch(() => {});
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("fullname");
      localStorage.removeItem("profileImage");
      localStorage.removeItem("emailConfirmed");
      localStorage.removeItem("isVerified");

      // éviter boucle infinie
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    };

    const resetTimer = () => {

      clearTimeout(timeout);

      timeout = setTimeout(() => {

        logout();

      }, 15 * 60 * 1000);
    };

    // Ne pas activer sur page login/register
    const publicPages = ["/login", "/register", "/forgotpassword"];

    if (!publicPages.includes(window.location.pathname.toLowerCase())) {

      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keydown", resetTimer);
      window.addEventListener("click", resetTimer);

      resetTimer();
    }

    return () => {

      clearTimeout(timeout);

      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
    };

  }, []);
};

export default useAutoLogout;